"use strict";

exports.__esModule = true;
exports.envExtraPermissions = exports.AccessCheck = void 0;
var _react = require("react");
var _expressAuthorization = _interopRequireDefault(require("express-authorization"));
var _Env = require("../../../Env");
var _AuthContext = require("../../AuthContext");
var _constants = require("../../constants");
var _dec, _dec2, _class, _AccessCheck;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Render-prop powered Access Check
 */
var AccessCheck = exports.AccessCheck = (_dec = _Env.EnvContext.withContext, _dec2 = _AuthContext.AuthContext.withContext, _dec(_class = _dec2(_class = (_AccessCheck = /*#__PURE__*/function (_Component) {
  function AccessCheck() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.isEnrichMode = function () {
      return _this.checkAccessRights([_constants.ACCESS_RIGHT_ENRICH]);
    };
    _this.isPermitted = function (permissions, permissionsToCheck) {
      var envExtra = envExtraPermissions && envExtraPermissions.length ? _expressAuthorization["default"].considerPermissions.apply(_expressAuthorization["default"], envExtraPermissions) : false;
      var auth = _expressAuthorization["default"].considerPermissions.apply(_expressAuthorization["default"], permissions);
      for (var _iterator = _createForOfIteratorHelperLoose(permissionsToCheck), _step; !(_step = _iterator()).done;) {
        var perm = _step.value;
        var isValid = envExtra && envExtra.isPermitted(perm) || auth.isPermitted(perm);
        if (!isValid) return false;
      }
      return true;
    };
    _this.checkAuth = function (permissionsToCheck) {
      var auth = _this.props.auth;
      return _this.isPermitted(auth.permissions, permissionsToCheck);
    };
    // This is made available for when the component API doesn't fit
    _this.checkAccessRights = function (checkForRights) {
      var env = _this.props.env;
      var ACCESS_RIGHTS = env.licence.accessRights;
      var hasPermission = !checkForRights || checkForRights.length === 0 || checkForRights.every(function (right) {
        return ACCESS_RIGHTS.includes(right);
      });
      if (!hasPermission) {
        // wait for ui-logger to log out issue
      }
      return hasPermission;
    };
    _this.canAccessOneOf = function (rights) {
      var env = _this.props.env;
      if (!rights || !rights.length) {
        return true;
      }
      return rights.some(function (right) {
        return env.licence.accessRights.includes(right);
      });
    };
    _this.isFeatureFlagEnabled = function (featureFlag) {
      var _env$featureFlags;
      var env = _this.props.env;
      return !!((_env$featureFlags = env.featureFlags) != null && _env$featureFlags.includes(featureFlag));
    };
    _this.isFeatureFlagsEnabled = function (featureFlags) {
      var env = _this.props.env;
      for (var _iterator2 = _createForOfIteratorHelperLoose(featureFlags), _step2; !(_step2 = _iterator2()).done;) {
        var _env$featureFlags2;
        var featureFlag = _step2.value;
        var hasAccess = !!((_env$featureFlags2 = env.featureFlags) != null && _env$featureFlags2.includes(featureFlag));
        if (hasAccess) return true;
      }
      return false;
    };
    _this.isComponentPermittedToRender = function (permission) {
      var renderPermissions = _constants.PERMISSIONS[permission];
      var isUserPermitted = !renderPermissions || !renderPermissions.permissions || !renderPermissions.permissions.length || renderPermissions.permissions.length && _this.checkAuth(renderPermissions.permissions);
      return renderPermissions && _this.checkAccessRights(renderPermissions.accessRights) && _this.canAccessOneOf(renderPermissions.rights) && isUserPermitted;
    };
    return _this;
  }
  _inheritsLoose(AccessCheck, _Component);
  var _proto = AccessCheck.prototype;
  _proto.checkFeatureFlags = function checkFeatureFlags(featureFlag, featureFlags) {
    return featureFlags && featureFlags > 0 ? this.isFeatureFlagsEnabled(featureFlags) : featureFlag ? this.isFeatureFlagEnabled(featureFlag) : true;
  }

  // Renders children only if the user has the specified permission
;
  _proto.render = function render() {
    var _permissions;
    var _this$props = this.props,
      permission = _this$props.permission,
      featureFlag = _this$props.featureFlag,
      featureFlags = _this$props.featureFlags;
    var permissions;
    if (typeof permission == "string") {
      permissions = [permission];
    } else {
      permissions = permission;
    }
    var isAllowed = (permissions ? !!((_permissions = permissions) != null && _permissions.some(this.isComponentPermittedToRender)) : true) && this.checkFeatureFlags(featureFlag, featureFlags);
    return this.props.children({
      isAllowed: isAllowed
    });
  };
  return AccessCheck;
}(_react.Component), _AccessCheck.defaultProps = {
  env: undefined,
  auth: undefined
}, _AccessCheck)) || _class) || _class);
var envExtraPermissions = exports.envExtraPermissions = function envExtraPermissions(alwaysAllowPermissions) {
  return (alwaysAllowPermissions || "").split(/\s*,\s*/).filter(function (p) {
    return p.length;
  });
};